// extracted by mini-css-extract-plugin
export var alertIcon = "_mx-0";